<template>
  <div class="home" id="quotaReviewList">
    <div style="text-align: left" >
      <el-form :inline="true" :model="queryForm" class="demo-form-inline">
        <el-form-item label="计薪汇总表编号：">
          <el-input v-model="queryForm.payrollSummary" placeholder="请输入查询" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="loadTable" icon="el-icon-search">查询</el-button>
          <el-button type="primary" @click="onReset" icon="el-icon-refresh-right">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
        <el-table  :header-cell-style="tableHeader" :cell-style="tableCell" :data="tableData" fit border style="width: 100%">
        <el-table-column type="index" width="50" />
        <el-table-column prop="payrollSummary" :show-overflow-tooltip="true"  label="计薪汇总表编号" />
        <el-table-column prop="status" :show-overflow-tooltip="true"  label="状态">
          <template slot-scope="scope">
            <div v-for="(item, index) in itemList" v-bind:key="index" >
              <div v-if="item.datavalue == scope.row.status">
                {{  item.name }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="examinepeople" :show-overflow-tooltip="true" label="审核人" />
        <el-table-column prop="examineTime" :show-overflow-tooltip="true" label="审核时间" />
        <el-table-column prop="updateTime" :show-overflow-tooltip="true" label="最后更新时间" />
        <el-table-column prop="submitUser" :show-overflow-tooltip="true" label="提交人员" />
        <el-table-column label="操作" >
          <template slot-scope="scope">
            <el-button @click="noDetails(scope.row)" type="text" size="small">详情</el-button> 
            <el-button type="text" size="small" v-if="scope.row.status!=2" @click="quotaReviewdiaLog(scope.row,0)" style="color: #09BF88">计薪审核</el-button>
            <el-button type="text" size="small" v-if="scope.row.status == 2" @click="quotaReviewdiaLog(scope.row,0)" style="color: #09BF88">发薪</el-button>
          </template>
        </el-table-column>
      </el-table>
     <el-pagination
        id="page"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        @prev-click="currentChange"
        @next-click="currentChange"
        :page-sizes="[5, 10, 20]"
        :page-size="queryForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <div>

      <el-dialog title="计薪审核" class="quotaReviewDialag" id="clear_layout" :visible.sync="dialogVisibledetails" @close="$refs['dialogform'].resetFields();">
        <el-form id="dialogform" :model="dialogform" :rules="rules" ref="dialogform" > 
          <el-form-item label="额度审核:" prop="radio" >
            <el-radio-group v-model="dialogform.radio">
              <el-radio  label="2">申请通过</el-radio>
              <el-radio  label="4">退回申请</el-radio>
          </el-radio-group>
              
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibledetails = false;"  >取 消</el-button>
          <el-button type="primary" @click="submitForm('dialogform')">确 定</el-button>
        </div>
      </el-dialog>
      

     
    </div>
  </div>
</template>
<script>

import XLSX from "xlsx"

import validateUtils from '@/util/validateUtils'

export default {
    data() {
      return {
        rules: {
           radio: [
            { required: true, message: '请选择计薪审核', trigger: 'change' }
          ],
        },
        queryForm: {
          id: '',
          payrollSummary:'',
          state: '',
          pageNo: 1,
          pageSize: 10
        },
        total:0,
        // 表格对象
        tableData: [],
      itemList: [],
      diction: {
					code: "summaryStatus",
				},
      dialogVisibledetails: false,
      dialogform: {
          radio: null,
      },
      quotaReviewdiaLog(row) {
       this.id=row.id;
				this.dialogVisibledetails = true;
			},
      }
    },
    computed: {
    },
    watch: {
    },
    // 实例创建完成后调用
    async created(){
	
	  this.loadTable();
    },

     mounted: function(){
				this.findDictionariesItemList(this.diction);
		},

    methods: {

      async quotaReview() {
        if(this.dialogform.radio == 2){
          this. dialogVisibledetails = false;
          var params = {
            id: this.id,
            sessionId: this.$getCookie("sessionId")
          };
          console.log("---------",params);
          await this.api.payrollSummary.updateAuditCompletedStatus(params).then(res =>{
            console.log("----------",res);
            if(res.data.code==200){
              this.$message({
                  message: '操作成功！',
                  type: 'success'
              });
              this.loadTable();
            }else{
              this.$message.error('操作失败！');
              this.loadTable();
            }
          });
        }else if (this.dialogform.radio == 4){
            this. dialogVisibledetails = false;
            var params = {
              id: this.id,
              sessionId: this.$getCookie("sessionId")
            };
            console.log("---------",params);
            await this.api.payrollSummary.updateAuditFailedStatus(params).then(res =>{
              console.log("----------",res);
              if(res.data.code==200){
                this.$message({
                    message: '操作成功！',
                    type: 'success'
                  });
               this.loadTable();
            }else{
              this.$message.error('操作失败！');
              this.loadTable();
            }
            });
        }
     
    },

       // 分页查看薪资信息列表
		async loadTable(){
			this.loading = true;
			let flag = this;
      console.log(this.queryForm);
			//getStaffList
			await this.api.payrollSummary.payrollSummaryApproval(this.queryForm).then((res) => {
				res = res.data
				console.log("----计薪列表-----",res);
				if(res.code == 200){
					flag.tableData = res.data.records;
					flag.total = res.data.total
				}else{
          this.tableData =  null;
          this.total = 0;
          this.$message.error(res.msg);
        }
			})
		},
    submitForm(formName) {
      console.log(formName)
        this.$refs['dialogform'].validate((valid) => {
          if (valid) {
                  console.log("22222222")
            this.quotaReview();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    
		warning(msg) {
        this.$message({
          message: msg,
          type: 'warning'
        });
      },

      success(msg) {
        this.$message({
          message: msg,
          type: 'success'
        });
      },
      // 查看函数
      noDetails(row){
        this.$router.push({path: '/salaryCalculation',query: {id: row.id,payrollSummary:row.payrollSummary,updateTime:row.updateTime}})
      },
      // 分页器 size改变是触发
       //current-change
      currentChange(page){
        this.queryForm.pageNo = page;
        this.loadTable();
      },

      // size-change
      sizeChange(size){
        this.queryForm.pageSize = size;
        this.loadTable();
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      
      // 重置
      onReset(){
        this.queryForm.payrollSummary='';
      },
      async findDictionariesItemList(param) {
				let response = await this.api.platformApi.findDictionariesItemList(param);
				console.log("数据字典", response);
				this.itemList = response.data.data;
			},
      tableHeader(column) {
        return "height:36px;background-color:#fafafa;color:#333333;padding:0";
      },
      tableCell(column) {
        return "height:40px;background-color:#fafafa;color:#000000;padding:0";
      },
    },
}
</script>

<style scoped>
  .submitMsg{
    color: #09BF88;
    font-size: 1.5rem;
    
  }
  .submitButton{
    background-color: #09BF88;
    border: none;
  }
  .submitButton:hover{
    background-color: #3ACCA0;
  }
  .repealMsg{
    color: #FFAC1D;
    font-size: 1.5rem;
  }
  .repealButton{
    background-color: #FFAC1D;
    border: none;
  }
  .repealButton:hover{
    background-color: #FFBD4A;
  }

  .cancellationMsg{
    color: #F78969;
    font-size: 1.5rem;
  }
  .cancellationButton{
    background-color: #F78969;
    border: none;
  }
  .cancellationButton:hover{
    background-color: #F789;
  }
/* -------------------------------------- */

#page {
  float: right;
  margin-top: 15px;
}

#quotaReviewList {
  overflow: hidden;
  background-color: white;
  padding: 15px 20px 100px;
}

.el-dialog__body {
  border-top: 1px solid rgba(228, 228, 228, 1);
  border-bottom: 1px solid rgb(228, 228, 228, 1);
  padding-left: 0;
  padding-right: 0;
}

.el-drawer.rtl {
  overflow: scroll;
}

.updateForm{
  width: 90%;
  margin: 0 auto;
}
.parseXlsxBottom{
  text-align: end;
  padding: 20px;
}
</style>


